import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from 'lib/request/api';
import type { HealthStatus } from './types';

const HEALTH_CHECK_INTERVAL = 15_000;

export const healthQueryOptions = queryOptions({
  queryKey: ['admin-health'],
  queryFn: ({ signal }) =>
    api.get('admin/health.json', { signal }).json<HealthStatus>(),
  refetchInterval: HEALTH_CHECK_INTERVAL,
});

/**
 * The app's health check, polled while the dashboard is open.
 * @return The health query
 */
export const useAdminHealth = () => useQuery(healthQueryOptions);
